module.exports = __webpack_public_path__ + "img/symbol_7.8944ae55.png";